import React from 'react';
import { compose, is } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import RichText from '@synergycms_core/components/generic/RichText';
import Icon from '@synergycms_core/components/generic/Icon';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { withContent } from '../../providers/translateProvider';
import styleFile from './Button.js';

const Button = class Button extends React.Component {
  static displayName = 'Button';

  render() {
    const { config, children, theme, content } = this.props;
    const { classes } = theme.styles;

    const quantityOrPlural = typeof config.quantity === 'number' ? config.quantity : config.plural || false;

    let textLabel = config.ariaLabel;
    if (textLabel && content && config.translate) {
      textLabel = content.t(textLabel, quantityOrPlural);
    }

    return (
      <button
        id={config.id}
        type={"button"}
        className={config.disabled ? [theme.computedInnerStyle, classes.disabled].join(' ') : theme.computedInnerStyle}
        onClick={(e) => config.onClick && config.onClick(e)}
        disabled={config.disabled}
        aria-label={textLabel}
        tabIndex={config.tabIndex}
        role={config.role}>
        {config.rightIcon ? <Icon config={config.rightIcon} /> : ''}
        {((config.richText || (children && is(String, children)) || config.text) && (
          <RichText config={config.richText}>{children || config.text}</RichText>
        )) ||
          children}
        {config.icon && <Icon innerStyle={classes.buttonIcon} config={config.icon} 
        />}
      </button>
    );
  }
};

export default compose(
  PropertyManager(['tabIndex','config', 'onClick', 'text', 'richText', 'icon', 'rightIcon', 'disabled', 'children', 'ariaLabel', 'translate','id','role']),
  withThemeJSS({ styleFile, link: true, index: 10 }),
  withContent('i18n')
)(Button);
